module.exports = __webpack_public_path__ + "img/394.4ff4f1c5.png";